// frontend/src/services/feedbackService.js
import api from './api';

export const submitTutorFeedback = async (studentId, term, feedback) => {
    const response = await api.post('/feedback', {
        student_id: studentId,
        term,
        feedback
    });
    return response.data;
};

export const getStudentFeedback = async (studentId) => {
    const response = await api.get(`/feedback/student/${studentId}`);
    return response.data;
};

export const getFeedbackStatus = async (term) => {
    const response = await api.get('/feedback/status', {
        params: { term }
    });
    return response.data;
};
